export default {
  primary: '#003942',
  primaryLight: '#05556285',
  bg: '#f4f6f9',
  grey: '#f8f9fa',
  grey200: '#eeeeee',
  grey300: '#dee2e6',
  grey400: '#ced4da',
  grey500: '#adb5bd',
  grey600: '#6c757d',
  gray700: '#495057',
  gray800: '#343a40',
  gray900: '#212529',
  danger: '#dc3545',
  success: '#28a745',
  warning: '#fff3cd',
  bootstrapWarning: '#ffc107',
  info: '#d1ecf1',
  state2: '#e7a163',
  modifiedObligations: '#00dae8',
  unfulfilled: '#E8E8D5',
  goWithConditions: '#dcd935',

  teacher: '#6bbf71',

  customColorList: [
    '#51896d',
    '#FFC8BA',
    '#E3AAD6',
    '#B5D8EB',
    '#FFBDD8',
    '#51896DFF',
  ],

  probSevRisk: ['#28a745', '#d7bc2e', '#ec8a33', '#dc3545'],
  accionaPenaltyRisk: ['#28a745', '#d7bc2e', '#ec8a33', '#dc3545'],
  caTaskStates: ['#48b363', '#e7a163', '#e04040', '#d0ca00'],
  totalEnergiesRiskRiskState: ['#FFC8BA', '#87BDB1', '#d0ca00', '#e7a163', '#B5D8EB', '#48b363'],
  totalEnergiesRiskControlState: ['#003D47', '#006170', '#00BAD6', '#87BDB1'],
  totalEnergiesRiskActionPlanState: ['#e7a163', '#48b363', '#e04040'],
  paletteColors: [
    '#003D47',
    '#006170',
    '#00778A',
    '#008296',
    '#00BAD6',
    '#68B3AF',
    '#87BDB1',
    '#AACCB1',
    '#C3DBB4',
    '#D3E2B6',
    '#1FCE92',
    '#4AD890',
    '#79E38E',
    '#B0EA84',
    '#D0EC7B',
    '#B00B00',
    '#C00C00',
    '#D00D00',
    '#E00E00',
    '#F00F00',
    '#A20075',
    '#B92669',
    '#D04C5E',
    '#E77152',
    '#FE9746',
    '#552C1B',
    '#8A3E20',
    '#C25B2B',
    '#D68335',
    '#E38B39',
  ],
};
